/* tslint:disable */
/* eslint-disable */
export enum CreateBiddersForAuctionConflictType {
  AuctionNotFound = 'auction_not_found',
  UserNotFound = 'user_not_found',
  BiddersAlreadyExistForAuction = 'bidders_already_exist_for_auction'
}
